module.exports = __webpack_public_path__ + "img/course_002.24ccd41.webp";